import styled from "styled-components";

export const GradientProgressBarStyled = styled.div`
    border-radius: 12px;
    background: var(--color-background-reduced);
    display: flex;
    align-items: center;
    overflow: hidden;
    width: 100%;
    gap: 2px;
    position: relative;
    border: 4px solid var(--color-background-reduced);
    
    &.reversed {
        flex-direction: row-reverse;
    }
    
    .message {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        color: var(--color-label-primary);
        font-size: 12px;
        line-height: 16px;
        border-radius: 4px;
        padding: 0 6px 2px 6px;
        background: var(--color-background-reduced);
        width: max-content;
    }
`;

export const GradientProgressBarItemStyled = styled.div`
    flex-grow: 1;
    flex-shrink: 0;
    height: 24px;
    border-radius: 2px;
    background: var(--color-fill-secondary);
    position: relative;
    
    &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: linear-gradient(139deg, #FFFC58 30.56%, #C0FCA3 85.16%);
        transition: opacity 0.2s;
        opacity: 0;
    }

    &.active::after {
        opacity: 1;
    }
`;